module.exports = function(media) {
	media
    .controller('newMediaController', newMediaController)

	newMediaController.$inject = ["keyPressOnlyNumber","$state","$scope", 'jQuery','$rootScope'];
	
    function newMediaController(keyPressOnlyNumber,$state,$scope,jQuery, $rootScope) {
    var vmnm = this;
    vmnm.data_grid = [];
    vmnm.editImageModal = false;
    vmnm.cancelMediaModal =function() {
       vmnm.editMediaModalShow = false;
        $rootScope.modalShow = false; 
    }
    vmnm.onlyNumber = function(event) {
       keyPressOnlyNumber(event) 
    }
    vmnm.editMedia = function (attachmentId){
        jQuery("html, body").animate({
        scrollTop: 0
      }, 600);
      $state.transitionTo('app.library', {id: attachmentId});
    }
    vmnm.deleteImage = function(id) {
        $scope.$broadcast('delete-photo-from-upload',{id:id});
    }
    
    jQuery(document).on('click','.upload-image',function() {
        var name = jQuery(this).attr('alt');
        for(var i=0; i<vmnm.data_grid.length;i++) {
            if(name == vmnm.data_grid[i].name) {
             vmnm.attachment_id = vmnm.data_grid[i]._id;
            $scope.$apply(function() {
                vmnm.editMediaModalShow = true;
                $rootScope.modalShow = true;
                vmnm.selectedMediatoEdit = i;
                vmnm.attachmentId = vmnm.data_grid[i]._id;
            })

            }
        }
    });
  }	
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/new-media/js/newMediaController.js
// module id = 522
// module chunks = 0